
import cx from 'classnames';
import Icon from '@components/common/Icon';
import ProductImage from '@components/common/ProductImage';
import {classList} from '../index';
import take from 'ramda/src/take';
import map from 'ramda/src/map';
import compose from 'ramda/src/compose';
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';

const SuggestedLineItem = product =>
    <div
        key={product.sku}
        className="inline-block mr-2 w-12 align-top border border-solid border-grey-lighter">
        <ProductImage {...product} className="block" width="90"/>
    </div>;

const renderLines = compose( map( SuggestedLineItem ), take( 3 ) );

const ReorderSummary = ( {list = []} ) => (
    isEmptyOrNil( list )
        ?
        null
        :
        <div data-testid="cart-reorder-summary"
             className={cx( classList.sectionBlock, 'h-24 overflow-hidden' )}
             style={{minHeight: '96px'}}>
            <a href="/reorder" className="p-4 flex-1 flex bg-near-white">
                <div className="flex-1">
                    <h3 className="mb-2 text-sm">Reorder from past purchases</h3>
                    <div id="reorder-summary-list" data-testid="cart-reorder-summary-list">
                        {renderLines( list )}
                    </div>
                </div>
                <Icon.ui name="arrow-right" className="text-lg" wrapperClassName="flex-shrink self-center"/>
            </a>
        </div>
);

export default ReorderSummary;
